import parseISO from 'date-fns/parseISO';
import { WidgetClinicOfficeHourFragment } from '../types/graphql';

export function isClinicOpen(clinicOfficeHours: Array<WidgetClinicOfficeHourFragment>): boolean {
  const now = new Date();
  const hours = clinicOfficeHours.find((day) => day.dayOfWeek === now.getDay());

  if (!hours) return true;
  if (!hours.isEnabled) return false;
  if (hours.isOpenTwentyFourHours) return true;

  const openTime: number = getTime(hours.openAt);
  const closeTime: number = getTime(hours.closeAt);

  return isNowInRange(openTime, closeTime);
}

function isNowInRange(openTime: number, closeTime: number): boolean {
  const now = new Date();
  return now.getTime() >= openTime && now.getTime() <= closeTime;
}

function getTime(isoDate: string): number {
  const date = parseISO(isoDate);
  const time = new Date();
  time.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), 0);
  return time.getTime();
}
